import { PAGES } from '../../utils/constants';

function Breadcrumbs({ currentPage, selectedUser, selectedDevice, onNavigate }) {
    const breadcrumbStyle = {
        padding: '10px 0',
        marginBottom: '20px',
        fontSize: '14px',
        color: '#666'
    };

    const linkStyle = {
        color: '#61dafb',
        textDecoration: 'none',
        cursor: 'pointer'
    };

    const separatorStyle = {
        margin: '0 8px',
        color: '#999'
    };

    return (
        <div style={breadcrumbStyle}>
            <span style={linkStyle} onClick={() => onNavigate(PAGES.HOME)}>
                🏠 Home
            </span>

            {currentPage === PAGES.WAN && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>🌐 WAN</span>
                </>
            )}

            {currentPage === PAGES.WIFI && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>📶 Wifi</span>
                </>
            )}

            {currentPage === PAGES.ALERTS && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>🚨 Alerts</span>
                </>
            )}

            {currentPage === PAGES.CRASH_REPORT && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>💥 Crash Report</span>
                </>
            )}

            {currentPage === PAGES.RESTARTS && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>🔁 Restarts</span>
                </>
            )}

            {currentPage === PAGES.USER_PREFERENCES && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>⚙️ User Preferences</span>
                </>
            )}

            {currentPage === PAGES.PREFERENCES && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>⚙️ Preferences</span>
                </>
            )}

            {currentPage !== PAGES.WAN &&
                currentPage !== PAGES.HOME &&
                currentPage !== PAGES.WIFI &&
                currentPage !== PAGES.ALERTS &&
                currentPage !== PAGES.CRASH_REPORT &&
                currentPage !== PAGES.RESTARTS &&
                currentPage !== PAGES.USER_PREFERENCES &&
                currentPage !== PAGES.PREFERENCES && (
                <>
                    <span style={separatorStyle}>/</span>
                    {currentPage === PAGES.USERS ? (
                        <span style={{ color: '#333' }}>👥 Users</span>
                    ) : (
                        <span style={linkStyle} onClick={() => onNavigate(PAGES.USERS)}>
                            👥 Users
                        </span>
                    )}
                </>
            )}

            {selectedUser && currentPage !== PAGES.WAN && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={linkStyle} onClick={() => onNavigate(PAGES.DEVICES, selectedUser)}>
                        📱 User {selectedUser} Devices
                    </span>
                </>
            )}

            {selectedDevice && currentPage !== PAGES.WAN && (
                <>
                    <span style={separatorStyle}>/</span>
                    <span style={{ color: '#333' }}>🚀 Device {selectedDevice} Deployments</span>
                </>
            )}
        </div>
    );
}

export default Breadcrumbs;